const q = require('queried');
const VotingItem = require('./voting-item');

class VotingList {
  constructor(feed) {
    this.element = feed;
    const elements = q.all('.post', this.element);

    this.items = elements.map((el) => new VotingItem(el));
    this.items.forEach((item) => item.on('change', () => this.render()));

    this.render();
  }

  render() {
    this.items.forEach((item) => {
      const disabled = Boolean(this.items
        .filter((i) => i !== item)
        .filter((i) => i.isVoted())
        .length);

      item.render(disabled);
    });
  }
}

module.exports = VotingList;
